import { Typography } from '@mui/material'
import ExpandedIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/ExpandedIcon'
import ExpandIcon from '@returnmates/ui-core/src/components/imageComponents/flyoutSidebar/ExpandIcon'
import { memo, useState } from 'react'

import useStyles from './styles'

interface Props {
  title: string
  children: React.ReactNode
  childrenType?: 'table' | 'form'
  isExpandedByDefault?: boolean
}

const ExpandableSection = ({
  title,
  children,
  childrenType = 'form',
  isExpandedByDefault = false,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(isExpandedByDefault)
  const classes = useStyles({ childrenType, isExpanded })

  const handleExpand = () => {
    setIsExpanded(prevIsExpanded => !prevIsExpanded)
  }

  return (
    <div className={classes.container}>
      <div className={classes.titleContainer} onClick={handleExpand}>
        <Typography className={classes.title}>{title}</Typography>
        {isExpanded ? <ExpandedIcon /> : <ExpandIcon />}
      </div>
      <div className={classes.childrenContainer}>{isExpanded ? children : null}</div>
    </div>
  )
}

export default memo(ExpandableSection)
